import { render, staticRenderFns } from "./TheSchedule.vue?vue&type=template&id=221502ff&"
import script from "./TheSchedule.vue?vue&type=script&lang=js&"
export * from "./TheSchedule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports